@if (listing) {
<div class="w-12 flex flex-middle bg-col-w b-t b-b b-col-4 pe-auto"
     [ngClass]="(displayModelViewSwitch && app.client.sizeId>1) ? 'flex-justify-between' : 'flex-justify-end'">

    @if (displayModelViewSwitch && app.client.sizeId>1) {
    <div class="inline-block float-right no-wrap va-t"
         style="margin-right: 0.5em;">
        <button class="inline-flex flex-middle p-l-10 p-r-10 b-r b-col-4 _listing-filters-button"
                [ngClass]="!productListingComponent?.modelView ? 'bg-col-5' : 'bg-col-w'"
                type="button"
                (click)="productListingComponent?.selectModelView(false)">
            <span class="p2">{{'Product' | translate}}</span>
        </button>
        <button class="inline-flex flex-middle p-l-10 p-r-10 b-r b-col-4 _listing-filters-button"
                [ngClass]="productListingComponent?.modelView ? 'bg-col-5' : 'bg-col-w'"
                type="button"
                (click)="productListingComponent?.selectModelView(true)">
            <span class="p2">{{'Model' | translate}}</span>
        </button>
    </div>
    }

    <div class="w-3 w-12-m w-12-s flex flex-middle cursor-pointer">
        <!-- listing size-->
        @if (listing.size) {
        <listing-size class="inline-block va-t"
                      [size]="listing.size" />
        }

        <div class="w-12 flex flex-middle">
            <div class="w-6 no-wrap">
                <!-- sort listing -->
                @if (listing.sort) {
                <listing-sort [sort]="listing.sort" />
                }
            </div>
            <!-- filter listing -->
            <filters class="w-6 va-t b-l b-col-4"
                     [listing]="listing"
                     [productListingComponent]="productListingComponent"
                     (filtersClose)="productListingComponent?.onFiltersClose()"
                     (filtersOpen)="productListingComponent?.onFiltersOpen()" />
        </div>
    </div>
</div>
}